<template>
  <popup size="custom" @codd_close="closeOnClick">
    <div v-if="!currentOrder" class="continue-shopping">
      <div class="cart-loader">
        <div class="lds-ripple"><div></div><div></div></div>
        <div>
          <span>{{ $t('cart.popup.title', { generator: generator }) }}</span>
        </div>
      </div>
    </div>
    <div v-if="currentOrder" class="continue-shopping">
      <div v-if="!error" class="title">
        <img class="check-icon" :src="getImage('check-motor.svg')" alt="check" />
        <span>{{ $t('cart.popup.success') }}</span>
      </div>
      <div v-else class="title">
        <img class="check-icon" :src="getImage('cross-motor.svg')" alt="check" />
        <span>{{ $t('cart.popup.failed') }}</span>
      </div>
      <div v-if="currentOrder && !error" class="product">
        <span><strong>{{ currentOrder.name }}</strong></span>
        <span class="description" v-if="currentOrder.description" v-html="currentOrder.description"></span>
        <span class="amount" v-if="currentOrder.amount && currentOrder.amount > 1">{{ $t('cart.popup.amount') }} {{currentOrder.amount}}</span>

        <div class="extras">
            <div v-for="extraProduct in currentOrder.extraProducts">
                <strong>{{ extraProduct.name }}</strong>
            </div>
        </div>

        <span class="price"><strong>&euro;&nbsp;{{ getPrice() }}</strong></span>
      </div>
      <div v-if="error" class="product">
        <span class="description">{{ $t('cart.popup.errorMessage') }}</span>
      </div>
      <div class="action-buttons">
        <span v-if="!error" @click="order" class="btn btn-order">
          {{ $t('cart.popup.toShoppingCart') }}
        </span>
        <span @click="configure" class="btn btn-continue">
          {{ $t('cart.popup.continueConfiguration') }}
        </span>
      </div>
    </div>
  </popup>
</template>
<script>
import Popup from "@/components/popup/Popup";
import {mapGetters} from "vuex";

export default {
  name: "PopupShoppingCart",
  components: {
    Popup,
  },
  props: {
    generator: {
      type: String
    }
  },
  computed: {
    ...mapGetters({
      currentOrder: 'cart/getCurrentOrder',
    }),
    error() {
      return !!this.currentOrder.error;
    },
  },
  methods: {
    order() {
      window.location.href = window.location.origin + '/checkout/cart';
    },
    configure() {
      this.$store.commit('cart/setCurrentOrder', null);
      this.$emit('close');
    },
    getPrice() {
      let price = this.currentOrder.price;
      if (this.currentOrder.amount) {
        price *= this.currentOrder.amount;
      }
      return (price / 100).toFixed(2).replace('.', ',')
    },
    closeOnClick() {
      if (this.currentOrder) {
        this.$store.commit('cart/setCurrentOrder', null);
        this.$emit('close');
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.continue-shopping {
  padding: 20px 30px;

  .cart-loader {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }

  .title {
    display: flex;
    font-size: 20px;

    .check-icon {
      width: 18px;
      margin-right: 5px;
    }
  }

  .product {
    margin: 20px 0;
    display: flex;
    flex-direction: column;

    .description {
      margin-bottom: 16px;
    }

    .amount {
      text-align: left;
    }

    .extras {
      margin-bottom: 16px;
    }
  }

  .action-buttons {
    display: flex;
    justify-content: space-between;

    .btn-order {
      display: flex;
      color: #fff;
      background-color: #3DB0C7;
      border-color: #3DB0C7;
      margin-right: 20px;
      cursor: pointer;
    }

    .btn-continue {
      color: #fff;
      background-color: #6c757d;
      border-color: #6c757d;
      cursor: pointer;
    }
  }

  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid #3DB0C7;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
}
</style>
